import React from 'react';

import Route from 'shared/components/Route';

export default function PublicRoute(props) {
  const { component: Component, ...rest } = props;

  return <Route {...rest} component={Component} />;
}
